import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";

import Modal from "react-modal";
import moment from "moment";
import { toast } from "react-toastify";

const ClsForm = (props) => {
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "20%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "800px",
      maxHeight: "auto",
      height: "auto",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const [loading, setLoading] = useState(false);

  const currentDate = new Date().toISOString().slice(0, 10);
  const frmRef = useRef({});

  const loadedGoodsRef = useRef({});
  const [loadedGoodsDetails, setLoadedGoodsDetails] = useState([]);
  const [loadedGoodsClose, setLoadedGoodsClose] = useState(false);

  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);
  const [employeeId, setEmployeeId] = useState();
  const [containerNo, setContainerNo] = useState();

  function getCurrentTime() {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();

    // Format hours and minutes with leading zeros if necessary
    hours = hours.toString().padStart(2, "0");
    minutes = minutes.toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  const { sendRequest: postCls } = useHttp();

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setEmployeeId(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getContainerNumber } = useHttp();

  useEffect(() => {
    getContainerNumber(
      {
        url: `/api/containerLoadingInspection/?warehouseId=${localStorage.getItem(
          "warehouseId"
        )}`,
      },
      (res) => {
        //console.log(res.ContainerLoading);
        setContainerNo(res.ContainerLoading);
      }
    );
  }, [getContainerNumber]);

  var d = new Date();
  var dateString =
    d.getDate() +
    "/" +
    (d.getMonth() + 1) +
    "/" +
    d.getFullYear() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes() +
    ":" +
    d.getSeconds();

  const submitHandler = (e) => {
    e.preventDefault();
    if (productDetails.length === 0) {
      toast.error("Product Details required");
      return;
    }
    if (loadedGoodsDetails.length === 0) {
      toast.error("Goods Loaded Condition Details required");
      return;
    }
    setLoading(true);

    const data = {
      clsDate: moment(frmRef.current.cls_date.value).format("DD/MM/YYYY"),
      supervisorEmployeeId: frmRef.current.emp_id.value,
      inspectionTime: frmRef.current.inspection_time.value,
      containerLoadingId: frmRef.current.container_number.value,
      containerTemperature: frmRef.current.container_temp.value,
      productDetails: productDetails,
      containerCondition: frmRef.current.container_condition.value,
      goodsLoadedCondition: loadedGoodsDetails,
      containerSealCondition: frmRef.current.container_seal_condition.value,
      sealNo: frmRef.current.seal_number.value,
      remark: frmRef.current.remark.value,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      status: 1,
      createdDate: dateString,
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      serviceId: props.sId,
    };
    if (props.update) {
      data["clsId"] = props.update.clsId;
    }
    //console.log(data);

    postCls(
      {
        url: "/api/containerLoadingSupervision/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        //console.log(data);
        toast.success(
          `Container Loading Supervision Data ${
            props.update ? "Updated" : "Added"
          }`
        );
        setLoading(false);
        props.addForm(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };
  useEffect(() => {
    //console.log(props.update);

    if (props.update) {
      // frmRef.current.cls_date.value = moment(props.update.clsDate).format(
      //   "YYYY-MM-DD"
      // );

      frmRef.current.emp_id.value = props.update.SupervisorEmployeeId;
      frmRef.current.inspection_time.value = props.update.inspectionTime;
      frmRef.current.container_number.value = props.update.containerNo;
      frmRef.current.container_temp.value = props.update.containerTemperature;
      setProductDetails(props.update.productDetails);
      frmRef.current.container_condition.value =
        props.update.containerCondition;
      setLoadedGoodsDetails(props.update.containerCondition);
      frmRef.current.container_seal_condition.value =
        props.update.containerSealCondition;
      frmRef.current.seal_number.value = props.update.sealNo;
      frmRef.current.remark.value = props.update.remark;
    }
  }, [props.update]);

  const submitGoodsLoaded = (e) => {
    e.preventDefault();
    setLoadedGoodsDetails((x) => [
      {
        palletId: loadedGoodsRef.current.pallet_id.value,
        outerPackaging: loadedGoodsRef.current.outer_packaging.value,
      },
    ]);
    setLoadedGoodsClose(false);
    //console.log(loadedGoodsDetails);
  };
  const { sendRequest: getProducts } = useHttp();

  const handleContainerIdChange = (e) => {
    //console.log(e.target.value);
    const id = e.target.value;

    getProducts(
      {
        url: `/api/containerLoadingProduct/?containerLoadingId=${id}`,
      },
      (res) => {
        //console.log(res.ContainerLoadingProduct[0].palletProductDetail);
        setProductDetails(res.ContainerLoadingProduct[0].palletProductDetail);
      }
    );
  };

  return (
    <>
      {loadedGoodsClose && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Goods Loaded Condition Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setLoadedGoodsClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-md-3">
              <label htmlFor={"pallet_id"}>Pallet Id</label>
              <input
                type={"input"}
                id={"pallet_id "}
                required
                ref={(el) => (loadedGoodsRef.current["pallet_id"] = el)}
                className="form-control"
              />
            </div>

            <div className="col-md-3">
              <label htmlFor={"outer_packaging"}>Outer Packaging</label>

              <select
                id="outer_packaging"
                className="form-control"
                ref={(el) => (loadedGoodsRef.current["outer_packaging"] = el)}
                required
              >
                <option value="Good">Good</option>
                <option value="Moderate">Moderate</option>
                <option value="Poor">Poor</option>
              </select>
            </div>
          </div>

          <div className="text-center mt-3">
            <button
              className="btn btn-sm btn-primary"
              onClick={submitGoodsLoaded}
            >
              Save
            </button>
          </div>
        </Modal>
      )}
      {close && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Product Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <table className="table table-sm table-bordered ">
            {" "}
            <thead>
              <tr className="">
                <th>Sr. No</th>
                <th>Item Id</th>
                <th>Item Description</th>
                <th>Product Sub Type </th>
                <th>Product Type Name</th>
                <th>Item Quantity</th>
                <th>Unit</th>
              </tr>
            </thead>
            <tbody>
              {productDetails &&
                productDetails.map((itm, i) => {
                  return (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{itm.productId}</td>
                      <td>{itm.productName}</td>
                      <td>{itm.productSubTypeName}</td>
                      <td>{itm.productTypeName}</td>
                      <td>{itm.boxQuantity}</td>
                      <td>{itm.unitAbbreviation}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          <hr />
          <div className="text-center mt-3">
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                setClose(false);
              }}
            >
              Close
            </button>
          </div>
        </Modal>
      )}

      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">&nbsp;
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Container Loading Supervision</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <br />
                  <div className="row mb-4">
                    <div className="col-md-3">
                      <label htmlFor={"cls_date"}> {"CLS Date"}</label>
                      <input
                        type={"date"}
                        id={"cls_date"}
                        required
                        ref={(el) => (frmRef.current["cls_date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={
                          props.update
                            ? props.update.clsDate
                                .split("/")
                                .reverse()
                                .join("-")
                            : selectedDate
                        }
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"emp_id"}>{"Assigned Supervisor"}</label>
                      <select
                        id="emp_id"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                        required
                      >
                        <option value="">Select</option>
                        {employeeId &&
                          employeeId.map((x) => (
                            <option
                              value={x.empId}
                              selected={
                                props.update &&
                                props.update.supervisorEmployeeId == x.empId
                              }
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"inspection_time"}>
                        {" "}
                        {"Inspection Time "}
                      </label>
                      <input
                        type={"time"}
                        id={"inspection_time"}
                        required
                        defaultValue={getCurrentTime()}
                        ref={(el) => (frmRef.current["inspection_time"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"container_number"}>
                        {"Container Number(No.) "}
                      </label>
                      <select
                        id="container_number"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["container_number"] = el)}
                        onChange={handleContainerIdChange}
                        required
                      >
                        <option value="">Select</option>
                        {containerNo &&
                          containerNo.map((x) => (
                            <option
                              value={x.containerLoadingId}
                              selected={
                                props.update &&
                                props.update.containerLoadingId ==
                                  x.containerLoadingId
                              }
                            >
                              {x.containerLoadingNo}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="row mb-4">
                    <div className="col-md-3">
                      <label htmlFor={"container_temp"}>
                        {" "}
                        {"Container Temperature (°C) "}
                      </label>
                      <input
                        type={"number"}
                        id={"container_temp"}
                        required
                        ref={(el) => (frmRef.current["container_temp"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        id={"product_details"}
                        autoComplete="off"
                        onClick={() => {
                          setClose(true);
                        }}
                        ref={(el) => (frmRef.current["product_details"] = el)}
                        className="btn btn-sm btn-success"
                      >
                        view
                      </button>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"container_condition"}>
                        {" "}
                        {"Container Condition"}
                      </label>
                      <select
                        id="container_condition"
                        className="form-control dropdowns"
                        ref={(el) =>
                          (frmRef.current["container_condition"] = el)
                        }
                        required
                      >
                        <option value="">Select</option>
                        <option value="Good">Good</option>
                        <option value="Contaminated">Contaminated</option>
                        <option value="Bad">Bad</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"goods_condition"}>
                        {" "}
                        {"Goods Loaded Condition"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        id={"goods_condition"}
                        ref={(el) => (frmRef.current["goods_condition"] = el)}
                        className="btn btn-sm btn-warning"
                        autoComplete="off"
                        onClick={() => {
                          setLoadedGoodsClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                  <div className="row mb-4">
                    <div className="col-md-3">
                      <label htmlFor={"container_seal_condition"}>
                        {" "}
                        {"Container Seal Condition"}
                      </label>
                      <select
                        id="container_seal_condition"
                        required
                        className="form-control dropdowns"
                        ref={(el) =>
                          (frmRef.current["container_seal_condition"] = el)
                        }
                      >
                        <option value="">Select</option>
                        <option value="No">No</option>
                        <option value="Yes">Yes</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"seal_number"}>
                        {"Seal Number(No.)"}
                      </label>
                      <input
                        type={"text"}
                        id={"seal_number"}
                        required
                        ref={(el) => (frmRef.current["seal_number"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className=" text-right">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ClsForm;
